var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMultiBet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44922 4.43359L8.23438 0.53125C9.18359 0.00390625 10.3789 0.320312 10.9062 1.23438L16.7773 11.4297C17.3398 12.3438 17.0234 13.5391 16.0742 14.1016L9.28906 18.0039C8.33984 18.5312 7.14453 18.2148 6.61719 17.3008L0.746094 7.10547C0.21875 6.19141 0.535156 4.99609 1.44922 4.43359ZM16.6367 15.0508C18.1133 14.207 18.6055 12.3086 17.7617 10.8672L12.9453 2.53516C13.0156 2.53516 13.0859 2.5 13.1562 2.5H21.0312C22.0859 2.5 23 3.41406 23 4.46875V16.2812C23 17.3711 22.0859 18.25 21.0312 18.25H13.1562C12.6641 18.25 12.207 18.1094 11.8906 17.793L16.6367 15.0508Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiBet);
export default ForwardRef;